import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {EstimatedReleaseSchedule} from '../../model/estimated-release-schedule';
import {DateUtils} from '../../utils/date-utils';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { FormsModule } from '@angular/forms';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';


@Component({
    selector: 'app-update-estimated-schedule-dialog',
    templateUrl: './update-estimated-schedule-dialog.component.html',
    styleUrls: ['./update-estimated-schedule-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatFormField, MatLabel, MatInput, FormsModule, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatDatepicker, MatButton, MatIcon]
})
export class UpdateEstimatedScheduleDialogComponent implements OnInit {
  private dialogRef = inject<MatDialogRef<UpdateEstimatedScheduleDialogComponent>>(MatDialogRef);
  private data = inject(MAT_DIALOG_DATA);


  schedule: EstimatedReleaseSchedule;
  readonly newSchedule: EstimatedReleaseSchedule;
  scheduleDate!: Date;
  private readonly maxQuantity: number;
  errorMessage!: string;

  constructor() {
    const data = this.data;

    this.maxQuantity = data.maxQuantity;
    this.schedule = data.schedule;
    this.newSchedule = JSON.parse(JSON.stringify(data.schedule));
    if (!this.newSchedule || !this.newSchedule.shipDate || this.newSchedule.shipDate.length !== 10) {
      this.cancel();
    }
  }

  ngOnInit(): void {
    this.scheduleDate = DateUtils.formatDisplay(new Date(this.newSchedule.shipDate));
  }

  save(): void {
    if (this.newSchedule.quantity <= 0) {
      this.errorMessage = 'Please specify a release quantity greater than 0';
    } else if (this.maxQuantity < this.newSchedule.quantity) {
      this.errorMessage = 'You only have ' + this.maxQuantity + ' units left to release';
    } else {
      this.schedule.quantity = this.newSchedule.quantity;
      this.schedule.shipDate = this.scheduleDate.toISOString().substring(0, 10);
      this.schedule.externalNotes = this.newSchedule.externalNotes;
      this.dialogRef.close(this.schedule);
    }
  }

  cancel(): void {
    this.dialogRef.close();
  }

}
